import { REDUX_DOMAIN_LIST_KEY, REDUX_KEY } from '../../constants/key'
import { createISOStrDateUtil } from 'packages/src'

function createDomainListReduxUtil () {
  const now = createISOStrDateUtil()
  return {
    [REDUX_KEY.DATA]: [],
    [REDUX_KEY.STATUS]: null,
    [REDUX_DOMAIN_LIST_KEY.LAST_ID]: null,
    [REDUX_KEY.CREATED_AT]: now,
    [REDUX_KEY.UPDATED_AT]: now
  }
}

export default createDomainListReduxUtil
